module.exports = __webpack_public_path__ + "static/media/creative-commons-nd.85d15b72.svg";